import PropTypes from "prop-types";
import { useLocation, useNavigate } from "react-router-dom";
import ModalCloseX from "../common/ModalCloseX";

export default function ReportPageHeader({
  title,
  titleAddon = null,
  onClose,
  closeTo = null,
  closeLabel = "Close report",
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const defaultCloseTo = location.pathname.startsWith("/superadmin/reports")
    ? "/superadmin/reports"
    : "/manager/reports";

  const handleClose = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    if (onClose) {
      onClose(event);
      return;
    }
    navigate(closeTo || defaultCloseTo, { replace: true });
  };

  return (
    <div className="bg-rose-500 px-6 py-4 flex items-center justify-between gap-4 relative">
      <div className="flex items-center gap-2">
        <h1 className="text-xl md:text-2xl font-semibold text-white">
          {title}
        </h1>
        {titleAddon}
      </div>
      <div
        className="absolute right-4 top-3 z-50"
        onClick={handleClose}
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
        }}
      >
        <ModalCloseX
          onClick={handleClose}
          ariaLabel={closeLabel}
          title={closeLabel}
        />
      </div>
    </div>
  );
}

ReportPageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  titleAddon: PropTypes.node,
  onClose: PropTypes.func,
  closeTo: PropTypes.string,
  closeLabel: PropTypes.string,
};
